var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keyboard-shortcuts-info"},[_vm._v("Pressione a tecla ENTER p/ Continuar"),_c('br'),_vm._v("Pressione a tecla ESC p/ Fechar")])
}]

export { render, staticRenderFns }